export const environment = {
    production: false,
    trackingId : "UA-118903825-2",
    api : "https://auth.esp-staging.omnissa-aws.com/api/auth/v1",
    espApi:"https://configmax-admin-svc.gid-uat.omnissa.com/",
    espApiLimits: "https://configmax-limits-svc.gid-uat.omnissa.com/",
    apiLogoutUrl: 'https://auth.esp-staging.omnissa-aws.com/api/auth/v2/logout',
    cspUrl: 'https://console-stg.cloud.omnissa.com/csp/gateway',
    orgId:"f9220ea1-d366-4537-a0b0-cfaea87dee84",
    orgLink:"/csp/gateway/am/api/orgs/f9220ea1-d366-4537-a0b0-cfaea87dee84",
    codeChallenge:"yfnZzZb0fuhyWsVVb9xXsLyV7LDA3A0j-MMNyPGIyhI",
    codeVerifier:"YnFU3stkVtkaJ6gkT-bfMc5PUl1WzRrIv9FKBnwrXChh05-FaV1qZAJgtJkAOKFF6L4m5JvwerJc9oUR1LmR1KRi0a_1_-HD1jbR2gSEylnD6B3O9rRQ0-ij1Yzry7nd",
    clientCSPId:'6naarekHTl7O0ZdXGL71y8GgmZDpPDDKOmU',
    redirectCSPUri: "https://configmax.gid-uat.omnissa.com/login/auth",
    ssoURL : "https://myvmware-stg.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/f2e62a99-c45d-4c19-8d36-3b2690c2f775",
    clientId : "esp-stg-428-nwzpw",
    state: "t3jbMJNi",
    authApiUrl: `https://authorization.esp.omnissa.com/api/authorize/v1/permissions/check?client_id=esp-stg-428-nwzpw`,
    espClientId: "configmax-client",
    redirectUri: "/login/auth",
    empAdUrl: "https://employee-ad.esp-staging.eng.omnissa.com/",
    localizationFilesPath: "https://wp-configuration.esp.omnissa.com/configurationapi/v1/configmax/labels/supportedvalues?locale=",
    whitneyUrl: "https://wp-configuration.esp.omnissa.com",
    whitneyAssetsUrl: "https://wp-configuration.esp-staging.omnissa-aws.com/configurationapi/assetsapi/v1/configmax/asset/"
  };



// WEBPACK FOOTER //
// ./src/environments/environment.stage.ts